import * as React from 'react';
import { TextField, ITextFieldProps, ITextFieldStyles } from '@fluentui/react/lib/TextField';
import { observer } from 'mobx-react-lite';

/** A text field with a visually hidden label that is used by screen readers. */
export default observer(function TextFieldWithHiddenLabel(props: ITextFieldProps) {
    const styles: Partial<ITextFieldStyles> = React.useMemo(() => {
        return {
            ...props.styles,
            subComponentStyles: {
                label: {
                    root: {
                        border: 0,
                        clip: 'rect(0 0 0 0)',
                        height: 1,
                        margin: -1,
                        overflow: 'hidden',
                        padding: 0,
                        position: 'absolute',
                        width: 1,
                    },
                },
            },
        };
    }, [props.styles]);

    const label = props.label ?? props.placeholder;

    return <TextField {...props} styles={styles} label={label} />;
});
